module.exports = __webpack_public_path__ + "img/合作精神.fb2e1c70.png";